import { useTheme } from '@mui/material';

import { ENOPOrganType, ORGAN_COLORS } from '#shared';

export const StyledDot = ({
  organType,
  radius = 1.5,
  ringWidth = 1,
  isNewCase = false,
  hubDot = false,
}: {
  organType?: ENOPOrganType;
  radius?: number;
  ringWidth?: number;
  isNewCase?: boolean;
  hubDot?: boolean;
}) => {
  const theme = useTheme();

  if (hubDot) {
    return (
      <circle
        cx="0"
        cy="0"
        r={radius + ringWidth * 2}
        fill="none"
        stroke={theme.palette.mapBlue[500]}
        strokeWidth={ringWidth}
        style={{ vectorEffect: 'non-scaling-stroke' }}
      />
    );
  }

  const organColor = organType ? ORGAN_COLORS[organType] || '#ccc' : '#ccc';
  const ringColor = isNewCase ? '#FF8C00' : '#ddd';

  return (
    <g style={{ vectorEffect: 'non-scaling-stroke' }}>
      {/* Inner filled circle */}
      <circle cx="0" cy="0" r={radius} fill={organColor} opacity={0.95} />

      {/* Outer ring */}
      <circle
        cx="0"
        cy="0"
        r={radius + ringWidth * 2}
        fill="none"
        stroke={ringColor}
        strokeWidth={ringWidth}
        opacity={0.95}
      />
    </g>
  );
};
